export const TOKEN = "user-authorization-token";
export const USER_ID = "authenticated-user-id";
export const CLIENT_ID = "client-id";



// WEBPACK FOOTER //
// ./src/utils/constants/localstoregeConstants.js